var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/object-is-prototype-of.js